export const zeroPad = (number, places) => {
  var zero = places - number.toString().length + 1
  return Array(+(zero > 0 && zero)).join('0') + number
}
